<script setup lang="ts">
import { computed } from 'vue'
import { userModule } from '@/store/user/module'
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    Modal,
    ModalContainer,
} = UIKit

const emit = defineEmits<{
    close: []
    submit: []
}>()

const isDarkMode = computed(() => {
    return userModule.state.settings.isDarkMode
})

const emitClose = () => {
    emit('close')
}

const emitSubmit = () => {
    emit('submit')
}
</script>

<template>
    <ModalContainer class="delete-card-modal" @close="emitClose">
        <template #modal>
            <Modal
                class="delete-card-modal__modal"
                :is-dark-mode="isDarkMode"
                showCloseButton
                @close="emitClose"
            >
                <p class="delete-card-modal__modal-title">Delete Card?</p>
                <p v-dark class="delete-card-modal__modal-message">
                    Your card will be deleted from our system.
                    It won't be an option for future purchases.
                </p>
                <div>
                    <PocketButton
                        class="delete-card-modal__modal-button"
                        type="secondary"
                        :is-dark-mode="isDarkMode"
                        @click="emitClose"
                    >
                        Never Mind
                    </PocketButton>
                    <PocketButton
                        class="delete-card-modal__modal-button"
                        :is-dark-mode="isDarkMode"
                        @click="emitSubmit"
                    >
                        Delete Card
                    </PocketButton>
                </div>
            </Modal>
        </template>
    </ModalContainer>
</template>

<style lang="scss" scoped>
.delete-card-modal {
    position: fixed;

    &__modal {
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        top: 100px;
        width: 392px;
        padding: 35px 0 26px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        @include breakpoint(black-bear) {
            width: 356px;
            height: auto;
            max-height: 638px;
            top: 10px;
        }
    }

    &__modal-title {
        font-size: 18px;
        line-height: 22px;
        font-weight: 600;
        width: 309px;
        margin: 0 auto 12px;
    }

    &__modal-message {
        font-size: 15px;
        line-height: 22px;
        color: $slate-03;
        margin-bottom: 29px;
        width: 300px;

        &--dark {
            color: $white;
        }
    }
}
</style>
